export default "__VITE_ASSET__CGMbDnge__"